import React from 'react';
import { motion } from 'framer-motion';
export function ContactCTA() {
  return <section id="contact" className="relative py-32 bg-charcoal px-6 overflow-hidden" data-id="element-77">
      {/* Subtle background pattern/texture could go here */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#C9A96E 1px, transparent 1px)',
      backgroundSize: '40px 40px'
    }} data-id="element-78"></div>

      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-79">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-80">
          <span className="text-gold uppercase tracking-[0.3em] text-sm font-medium mb-6 block" data-id="element-81">
            Take the Next Step
          </span>

          <h2 className="text-4xl md:text-6xl font-serif text-white mb-8 leading-tight" data-id="element-82">
            Begin Your <br data-id="element-83" />
            <span className="italic text-gold" data-id="element-84">Las Vegas Journey</span>
          </h2>

          <p className="text-lg text-white/70 font-light mb-12 max-w-2xl mx-auto" data-id="element-85">
            Whether you are seeking to acquire a new estate or list your current
            property, our team of luxury specialists is ready to provide an
            exceptional real estate experience.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6" data-id="element-86">
            <a href="tel:+18583978218" className="px-8 py-4 bg-gold text-white uppercase tracking-widest text-sm hover:bg-gold-light transition-colors duration-300 w-full sm:w-auto" data-id="element-87">
              Call (858) 397-8218
            </a>
            <a href="mailto:jenny@jennygong.com" className="px-8 py-4 border border-gold text-gold uppercase tracking-widest text-sm hover:bg-gold hover:text-white transition-colors duration-300 w-full sm:w-auto" data-id="element-88">
              Email Us
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}